module.exports = __webpack_public_path__ + "bootleggers_coffee_font02.jpg?3a847b4fe71f2658560b6d0f7ee07e33";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggers_coffee_font02.jpg
// module id = 36
// module chunks = 0